const defaults = {
  loadspeed: 9,
  char: "-",
  hideChaar: true,
  delay: 2500,
  loop: true,
  randomizeEl: true,
};

export default defaults;
